import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './resumerequest.css';

function Resumerequest({ onClose }) {
  const [formData, setFormData] = useState({
    email: '',
    Verification: '',
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.sendForm('default_service', 'template_bstvtn9', e.target, 'PRb_GDLhvtr54sgUl')
      .then((result) => {
        console.log(result.text);
        setStatus('success');
        setFormData({ email: '', Verification: '' });
        setTimeout(() => setStatus(null), 3000);
      }, (error) => {
        console.log(error.text);
        setStatus('error');
        setTimeout(() => setStatus(null), 3000);
      });
  };

  return (
    <div className="resume-popup-overlay">
      <div className="resume-popup">
        <button className="close-popup" onClick={onClose}>X</button>
        <h2>Request My Resume & Certificates</h2>
        <p>Enter your E-Mail and company information to receive my official papers and certifications within 48 hours.</p>

        <form onSubmit={handleSubmit} id="resume-request-form">
          <div className="form-group">
            <label htmlFor="email">Your Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="Verification">Link to your Company</label>
            <input
              type="text"
              id="Verification"
              name="Verification"
              value={formData.Verification}
              onChange={handleChange}
              placeholder="company-example.com"
              required
            />
          </div>

          <button 
            type="submit"
            className={status ? `status-${status}` : ''}
            disabled={status === 'sending'}
          >
            {status === 'sending' && 'Sending...'}
            {status === 'success' && 'Request Received!'}
            {status === 'error' && 'Failed! Please Try Again'}
            {!status && 'Request Resume'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Resumerequest;